// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_RevenueConciliationLinkRecebimentosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_RevenueConciliationLinkRecebimentosResponseDados {
linked_count: number
already_claimed_count: number
no_execution_count: number
}

export type Payroll_RevenueConciliationLinkRecebimentosResponse = ApiResponse<Payroll_RevenueConciliationLinkRecebimentosResponseDados>;

registerResponseContract('Payroll_RevenueConciliationLinkRecebimentosResponse', {
  linked_count:          { type: 'number',  required: true },
  already_claimed_count: { type: 'number',  required: true },
  no_execution_count:    { type: 'number',  required: true },
})
